import * as React from "react";
const SvgCloseCircle24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM6.79.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 6.79.837ZM9.586 11 6.793 8.207l1.414-1.414L11 9.586l2.793-2.793 1.414 1.414L12.414 11l2.793 2.793-1.414 1.414L11 12.414l-2.793 2.793-1.414-1.414L9.586 11Z",
      clipRule: "evenodd"
    })
  );
export default SvgCloseCircle24Px;
